import { Media } from "../media/media.type";

export enum Roles {
  support = "ROLE_SUPPORT",
  manager = "ROLE_MANAGER",
  waiter = "ROLE_WAITER",
  kitchen = "ROLE_KITCHEN",
  cashier = "ROLE_CASHIER",
  admin = "ROLE_ADMIN",
  user = "ROLE_USER",
  owner = "ROLE_OWNER",
  // Back-office user with no default permissions — access comes entirely from
  // assigned access roles.
  staff = "ROLE_STAFF",
}
export interface User {
  id: string;
  fullName: string;
  // Null for users who log in by phone only.
  email: string | null;
  phone: string;
  status: boolean;
  image: Media;
  roles: Roles[];
  // Action-level permissions granted on top of the base role (from
  // /api/users/current). For managers/owners this contains every permission.
  effectivePermissions?: string[];
  // True only when the user is the PRIMARY manager of the current restaurant
  // (never true for owners). A primary manager has full access on their
  // restaurant. From /api/users/current.
  isPrimaryManager?: boolean;
  // Present on rows of the restaurant employees list (dismissal target).
  employeeId?: string;
  // Timestamp of the user's last successful authentication (null if they have
  // never logged in). Set automatically by the API on every login.
  lastLoginAt?: string | null;
  // New phone/email waiting for the code sent to it (SFAPI-207). From
  // /api/users/current.
  pendingIdentifier?: string | null;
}

export type UserFormData = Pick<User, "fullName" | "phone"> & {
  roles: Roles[];
  email?: string;
  image?: string;
  newImageUrl?: string;
};
